import { useEffect, useRef } from 'react';
import { Login } from '../Login';
import { RequireAuthN } from '../RequireAuth';
import { authenticatedPostRequest } from '../RestApi';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { ampli } from '../../amplitude';
import { useNavigate } from 'react-router-dom';

const HandleUserLanding = () => {
    const { authStatus, user } = useAuthenticator((context) => [context.authStatus, context.user]);
    const navigate = useNavigate();
    const hasHandledLanding = useRef(false);

    useEffect(() => {
        const handleLanding = async () => {
            const invitationCode = document.cookie.split('; ').find(row => row.startsWith('invitation_code='))?.split('=')[1];

            if (invitationCode && user && authStatus === 'authenticated') {
                try {
                    await authenticatedPostRequest(`${process.env.REACT_APP_SUBSCRIPTION_API_URL}/coupons/claim`, {
                        couponCode: invitationCode,
                        cognitoSub: user.signInUserSession.idToken.payload.sub
                    });
                    document.cookie = 'invitation_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                } catch (error) {
                    console.error('Failed to claim invitation code:', error);
                }
            }

            await Promise.all([
                ampli.identify(user.signInUserSession.idToken.payload.sub),
                ampli.login(),
                ampli.commonLoginCompleted()
            ]);

            await ampli.flush();

            navigate('/launchpad', { replace: true });
        };

        if (hasHandledLanding.current) return;
        if (authStatus === 'authenticated' && user?.signInUserSession?.idToken?.payload?.sub) {
            hasHandledLanding.current = true;
            handleLanding();
        }
    }, [user, authStatus, navigate]);

    return null;
};

export const openPreviewModal = () => {
    window.dispatchEvent(new CustomEvent('openPreviewModal'));
};

export const Dashboard = ({ errorInfo, isReturnedOAuthError }) => {
    return (
        <>
            {isReturnedOAuthError ? (
                <Login tab="signIn" errorInfo={errorInfo} />
            ) : (
                <RequireAuthN>
                    <HandleUserLanding />
                </RequireAuthN>
            )}
        </>
    );
};
